import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import { Node } from 'slate';
import { SfEditor } from '../../custom/custom';
import getEventTransfer from '../../custom/get-event-transfer';
import generateBlockquote from '../../element-model/blockquote';
import { htmlDeserializer } from '../../../utils/deserialize-html';
import { normailizeSelection } from '../selection-utils';
var BlockquoteUtils = /*#__PURE__*/_createClass(function BlockquoteUtils(editor) {
  var _this = this;
  _classCallCheck(this, BlockquoteUtils);
  this.getCurrentBlockquote = function () {
    var block = SfEditor.match(_this.editor, _this.editor.selection.anchor, 'block');
    var blockPath = block[1];
    var parent = Node.parent(_this.editor, blockPath);
    if (parent && parent.type === 'blockquote') {
      return parent;
    }
    return null;
  };
  this.isInBlockquote = function () {
    return Boolean(_this.getCurrentBlockquote());
  };
  this.wrapBlockquote = function () {
    normailizeSelection(_this.editor);
    var selection = _this.editor.selection;
    var currentPath = SfEditor.path(_this.editor, selection);
    var outestElementAtPath = _this.editor.children[currentPath[0]];
    var blockquote = generateBlockquote({
      children: [outestElementAtPath]
    });
    SfEditor.wrapNodes(_this.editor, blockquote);
  };
  this.unwrapBlockquote = function () {
    normailizeSelection(_this.editor);
    SfEditor.unwrapNodes(_this.editor, {
      split: true,
      match: {
        type: 'blockquote'
      }
    });
  };
  this.pasteContentInBlockquote = function (command) {
    var data = command.data;
    var _getEventTransfer = getEventTransfer(data),
      fragment = _getEventTransfer.fragment,
      text = _getEventTransfer.text,
      type = _getEventTransfer.type,
      html = _getEventTransfer.html;
    if (type === 'text') {
      var textArray = text.split(/\r\n|\n/g);
      textArray.forEach(function (text, index) {
        if (index === 0) {
          SfEditor.insertText(_this.editor, text);
        } else {
          SfEditor.insertNodes(_this.editor, {
            type: 'paragraph',
            children: [{
              text: text
            }]
          });
        }
      });
      return;
    }
    if (type === 'html') {
      fragment = htmlDeserializer(html);
    }
    var block = SfEditor.match(_this.editor, _this.editor.selection, 'block');
    if (Node.text(block[0]).length === 0) {
      SfEditor.removeNodes(_this.editor, {
        match: 'block'
      });
    }
    SfEditor.insertNodes(_this.editor, fragment);
    return;
  };
  this.editor = editor;
});
export default BlockquoteUtils;